import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { ChargeResponse, Order, PaymentModalOrderResponse, Topup } from '@/modules/in-game-payments'

const emptyStatus = {
    order: null as Order | Topup | null,
    resolve: null as (<T extends Order | Topup>(value: ChargeResponse<T>) => void) | null,
    reject: null as ((reason: unknown) => void) | null,
}

export const useLayoutStore = defineStore('layout', () => {
    const fullScreen = ref(false)

    function setFullscreen(value: boolean) {
        fullScreen.value = value
    }

    const categoriesModalOpened = ref(false)

    function setCategoriesModalOpened(value: boolean) {
        categoriesModalOpened.value = value
    }

    const inviteModalOpenedReason = ref<boolean | 'need_more_fennecs'>(false)

    function setInviteModalOpened(value: typeof inviteModalOpenedReason.value) {
        inviteModalOpenedReason.value = value
    }

    const signInModalOpened = ref(false)

    function setSignInModalOpened(value: boolean) {
        signInModalOpened.value = value
    }

    const isReportBugModalOpen = ref(false)

    function setIsReportBugModalOpen(value: boolean) {
        isReportBugModalOpen.value = value
    }

    const paymentModalOrder = ref(emptyStatus)
    const isPaymentModalOpen = computed(() => Boolean(paymentModalOrder.value.order))

    function setPaymentModalOrder<T extends Order | Topup | null>(value: T) {
        if (!value) {
            paymentModalOrder.value.order = null
            paymentModalOrder.value.reject = null
            paymentModalOrder.value.resolve = null
            return undefined as PaymentModalOrderResponse<T>
        }

        return new Promise<ChargeResponse<typeof value>>((resolve, reject) => {
            paymentModalOrder.value.order = value
            // some weird error - typescript can't match templates
            // @ts-expect-error types of T are incompatible (though they are the same)
            paymentModalOrder.value.resolve = resolve
            paymentModalOrder.value.reject = reject
        }) as PaymentModalOrderResponse<T>
    }

    const questionSurveyInfo = ref<{ questionSeedNum: number; hru: string; taskId: string } | null>(null)
    const isSurveyModalOpened = computed(() => questionSurveyInfo.value !== null)

    function setSurveyModalSurveyInfo(value: { questionSeedNum: number; hru: string; taskId: string } | null) {
        questionSurveyInfo.value = value
    }

    return {
        setFullscreen,
        fullScreen,
        setCategoriesModalOpened,
        categoriesModalOpened,
        setInviteModalOpened,
        inviteModalOpenedReason,
        setSignInModalOpened,
        signInModalOpened,
        setIsReportBugModalOpen,
        isReportBugModalOpen,
        isPaymentModalOpen,
        questionSurveyInfo,
        isSurveyModalOpened,
        setSurveyModalSurveyInfo,
        paymentModalOrder,
        setPaymentModalOrder,
    }
})
